import React from 'react'
import { useSelector } from 'react-redux'
import cx from 'classnames'

import * as Text from '@piconetworks/pkg-text'
import * as Box from '@piconetworks/pkg-box'

import AccountModule from 'modules/account'
import SettingsModule from 'modules/settings'

import { useFeatureManager, constants } from 'features/FeatureManager'
import HypePluginLink from 'containers/Workflows/Links/Products/HypePluginLink'
import ContentSection from 'components/ContentSection'

import styles from './Alert.module.scss'

const ProductsAlert = () => {
    const publisherId = useSelector(AccountModule.selectors.getPublisherId)
    const userId = useSelector(SettingsModule.selectors.getMeDataUserId)

    const { getAppTierByLabel, hasFeature } = useFeatureManager({ publisherId, userId })

    const hasHypePlugin = hasFeature(constants.GADGET_ACCESS_FEATURE) || hasFeature(constants.WIDGET_FEATURE)
    const hasMultiplePages = getAppTierByLabel(constants.TIER_10)?.has_access

    if (hasMultiplePages && hasHypePlugin) {
        return null
    }

    return (
        <ContentSection.Container
            className={cx(
                styles.contentWrapper,
                styles.grayBackground,
                styles.info
            )}
        >
            <Box.Flexbox.Container
                flexDirection="column"
                className={styles.container}
            >
                <ContentSection.Child className={styles.child}>
                    <Text.P className={styles.headerText}>
                        {!hasHypePlugin && (
                            <>
                                To offer a Product on your custom-built website in a
                                popup, subscribe to <HypePluginLink />.
                            </>
                        )}
                    </Text.P>
                </ContentSection.Child>
            </Box.Flexbox.Container>
        </ContentSection.Container>
    )
}
export default ProductsAlert
